module.exports = __webpack_public_path__ + "static/media/add-new-report.09265def.svg";